// ============================================================
//  ENSAMBLADOR DEL CHATBOT
//
//  ✏️  Para editar el contenido, abre el archivo de la sección:
//       data/inicio.ts        → Menú principal
//       data/modulos.ts       → Lista de módulos de negocio (vacía en esta plantilla)
//       data/acceso.ts        → Problemas de acceso
//       data/reportes.ts      → Reportes y exportaciones
//       data/temas.ts         → Apariencia y temas
//
//  ➕  Para agregar una nueva sección (p.ej. un módulo de negocio propio):
//       1. Crea un nuevo archivo en data/ (copia cualquiera como referencia)
//       2. Impórtalo aquí abajo
//       3. Agrégalo en 'secciones' con el nombre que usaste en 'llevaA'
// ============================================================

import { INICIO         } from './data/inicio'
import { MODULOS        } from './data/modulos'
import { ACCESO         } from './data/acceso'
import { REPORTES       } from './data/reportes'
import { TEMAS          } from './data/temas'

export const CHATBOT_DATA = {

  // Nombre del asistente que aparece en la cabecera del chat
  botName: 'Asistente TSI BETA',

  // Mensaje que ve el usuario al abrir el chat
  welcomeMessage: '¡Hola! Soy el asistente virtual del ERP TSI. ¿En qué puedo ayudarte?',

  // Texto que se muestra cuando se sugiere contactar a soporte
  contactInfo: '💬 Si el problema persiste, comunícate con soporte técnico de TSI.',

  secciones: {
    inicio:        INICIO,
    modulos:       MODULOS,
    acceso:        ACCESO,
    reportes:      REPORTES,
    temas:         TEMAS,
  }
}
